import { configureStore } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import metaReducer from './meta';
import sessionReducer from './session';
import assessmentReducer from './assessment';
import matchingReducer from './matching';
import ldFlagsReducer from './ld-flags';
import experimentsReducer from './experiments';

const store = configureStore({
  reducer: {
    meta: undoable(metaReducer),
    session: sessionReducer,
    assessment: assessmentReducer,
    matching: matchingReducer,
    ldFlags: ldFlagsReducer,
    experiments: experimentsReducer,
  },
  devTools: process.env.NEXT_PUBLIC_DD_ENV !== 'prod',
});

export default store;
